import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}

import { initBiPoint } from '../../resource/plugins/biPoint/index';
import App from '../../App.vue';
import router from '../rooters/passport';
import store from '../stores/passport';
import clickThrottling from '../../resource/plugins/clickThrottling';
import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';
import globalConfig from '../../resource/utiles/globalConfig';
import AnalyzePoint, {
  routerEnter
} from '../../resource/plugins/AnalyzePoint/index';
import touchActive from '../../resource/diractives/touchActive';
import '@plugins/replaceAllPolyfills';
Vue.directive('touchActive', touchActive);
Vue.use(AnalyzePoint('global-passport', 'passport', true));

globalConfig.setPageTitleAndIco('passport center');
Vue.config.productionTip = false;
setCommonPlugins(Vue);

initBiPoint({ dataLayerName: 'passportDataLayer' });

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);

globalConfig.setVuePrototypePlatformConfig(Vue);
Vue.prototype.$isSupport = false;

router.beforeEach((to, from, next) => {
  routerEnter(to.name);
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#passport');
